module.exports = __webpack_public_path__ + "static/img/ME.c82c1a80.svg";